module.exports = __webpack_public_path__ + "static/media/add_block_btn.788dc3bc.svg";